const PERM_TIME_ZONE = 'Asia/Yekaterinburg'

export const formatPermDateShort = (date: Date = new Date()): string =>
  new Intl.DateTimeFormat('ru-RU', {
    timeZone: PERM_TIME_ZONE,
    day: '2-digit',
    month: '2-digit',
    year: '2-digit',
  }).format(date)

export const defaultSupplierRfqTitle = (date: Date = new Date()): string =>
  `Закупка ${formatPermDateShort(date)}`
